// services/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCddYIwuZZmbOP6trzuBPcNZkQWgyALMIA",
  authDomain: "hire100x-e1dd4.firebaseapp.com",
  projectId: "hire100x-e1dd4",
  storageBucket: "hire100x-e1dd4.firebasestorage.app",
    messagingSenderId: "964389965343",
    appId: "1:964389965343:web:d6ac19eaac488cfa440f2a",
    measurementId: "G-GWRKFHDZP1"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

export { app, functions };